import {createAction} from 'redux-actions';
import {push} from "connected-react-router";
import {mediaAudioStateSelector} from './selectors';
import {
    createLlamaStateSelector,
    createStickerIdSelector,
} from '../create-llama/selectors';
import cacheManager from '../../domain/services/StickerCache';
import fileUploader from "../../../upload/FileUploader";
import {setPreparedMedia} from '../create-llama/actions';
import authService from "../../../auth/domain/services/AuthService";
import {isCurrentUserLoggedSelector, currentUserSelector} from '../../../auth/store/auth-user/selectors';
import stickerItemsRepositoryBuilder from '../../domain/factories/StickerItemsRepositoryBuilder';
import {getCookie} from '../../../../infrastructure/helpers';
import {setGeneratingLoaderProgress} from "../../../layout/store/actions";
import * as Noty from 'noty';

const namespace = 'MEDIA_AUDIO';

export const setOriginAudio = createAction(`${namespace}/SET_ORIGIN_AUDIO`);
export const setAudioDuration = createAction(`${namespace}/SET_AUDIO_DURATION`);
export const resetAudioInfo = createAction(`${namespace}/RESET_AUDIO_INFO`);
export const restoreAudio = createAction(`${namespace}/RESTORE_STATE`);

export function onAudioDone() {
    return (dispatch, getState) => {
        const audioState = mediaAudioStateSelector(getState());
        const stickerState = createLlamaStateSelector(getState());
        const stickerId = createStickerIdSelector(getState());
        const uploadAudioPromise = () => {
            uploadAudio(dispatch, getState)
                .then((uploadedAudio) => {
                    cacheManager.cacheUploadedMedia(stickerState, uploadedAudio);
                    dispatch(setPreparedMedia(uploadedAudio));
                })
                .then(() => {
                    fileUploader.onUploadComplete && fileUploader.onUploadComplete()
                })
        };

        cacheManager.cacheMediaAsBlob(stickerState, audioState);
        dispatch(push(`/stickers/${stickerId}/new/preview`));
        if (isCurrentUserLoggedSelector(getState())) {
            uploadAudioPromise();
        } else {
            authService.signInAnonymously()
                .then(() => {
                    fileUploader.isUploading = true;
                    uploadAudioPromise();
                });
        }
    };
}

export function onAudioRecorded(audioInfo) {
    return (dispatch, getState) => {
        dispatch(setOriginAudio(audioInfo));
    };
}

export function uploadAudio(dispatch, getState) {
    const {currentDuration, originAudioBlob} = mediaAudioStateSelector(getState());
    const stickerState = createLlamaStateSelector(getState());

    const folderName = stickerState.scannedSticker.id;

    const accessToken = getCookie('accessToken');

    return stickerItemsRepositoryBuilder.buildWithStickerItem(stickerState)
        .canCurrentUserWriteInStickerItem(stickerState.scannedSticker, accessToken)
        .then(() =>
            currentUserSelector(getState()).getIdToken(true)
                .then((token) => {
                    authService.setAuthTokenInHeaders(token)
                })
                .then(() =>
                    fileUploader.upload(originAudioBlob, {withExt: true, folderName}, (progress) => {
                        dispatch(setGeneratingLoaderProgress(progress));
                    })
                        .then((result) => {
                            dispatch(setGeneratingLoaderProgress(null));
                            return {
                                duration: currentDuration,
                                original: result,
                            };
                        })
                )
        )
        .catch(() => {
            new Noty({
                type: 'error',
                timeout: 3000,
                text: `Sticker access error`,
            }).show();
        })

}
